import request from '@/utils/http';
import store from '@/store/index';

const supplierCode = store.state.supplier.supplierCode;

// 预警待办-看板
export const warningQuantity = () => {
    return request({
        url: `/api-srm-web/warehouseWorkbench/warningQuantity`,
        method: 'get',
    });
};

// 仓储委派函-看板
export const delegateQuantity = () => {
    return request({
        url: `/api-srm-web/warehouseWorkbench/supplierWarehouseDelegate/quantity`,
        method: 'get',
    });
};

// 绩效整改-看板
export const performanceQuantity = () => {
    return request({
        url: `/api-srm-web/warehouseWorkbench/supplierLegalPersonPerformance/quantity`,
        method: 'get',
    });
};

// 招标公告列表接口
export const supplierNoticeHomePage = (data) => {
    return request({
        url: `/api-srm-web/bid/portal/supplierNoticeHomePage`,
        method: 'POST',
        data
    });
};



// 财务待办
export const getBmsInfo = () => {
    return request({
        url: `/api-bms-web/bmsExternalCall/numberToDo`,
        method: 'GET'
    });
};

// 往来代办
export const getStatementInfo = (params) => {
    return request({
        url: `/api-bms-web/efApDealingsBill/getApDealingsBillList`,
        method: 'POST',
        data: params
    });
};
